'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Actions


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _ElementCreatePopup = require('./ElementCreatePopup');

var _ElementCreatePopup2 = _interopRequireDefault(_ElementCreatePopup);

var _popupActions = require('../../../components/popupPanel/popupActions');

require('./ElementCreateUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openPopupPanel: function openPopupPanel() {
            dispatch((0, _popupActions.togglePopup)('element-create'));
        }
    };
};

var ElementCreateUtil = function ElementCreateUtil(props) {
    var openPopupPanel = props.openPopupPanel,
        showCreateButton = props.showCreateButton;


    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('ElementCreateUtil', { leave: !showCreateButton }) },
        _react2.default.createElement(
            _Button2.default,
            { className: 'highlight', onClickFn: openPopupPanel },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_Icon2.default, { name: 'nav-create' })
            )
        ),
        _react2.default.createElement(_ElementCreatePopup2.default, _extends({}, props, { isMobileView: true }))
    );
};

ElementCreateUtil.propTypes = {
    openPopupPanel: _propTypes2.default.func,
    showCreateButton: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ElementCreateUtil);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/elementCreate/ElementCreateUtil.js
// module id = 2214
// module chunks = 0